import KeyStatisticsChart from "Components/Charts/KeyStatistics";
import LanguageAndCultureChart from "Components/Charts/LanguageAndCulture";
// TODO: rename `EducationChart` to `SocioEconomicCharacteristicsChart`
import SocioEconomicCharacteristicsChart from "Components/Charts/SocioEconomicCharacteristics";
// import EmploymentChart from "Components/Charts/Employment";
import HouseholdsChart from "Components/Charts/Households";
import OtherChart from "Components/Charts/Other";

import KeyStatisticsTable from "Components/Tables/KeyStatistics";
import LanguageAndCultureTable from "Components/Tables/LanguageAndCulture";
import SocioEconomicCharacteristicsTable from "Components/Tables/SocioEconomicCharacteristics";
import HouseholdsTable from "Components/Tables/Households";
import OtherTable from "Components/Tables/Other";

export const categoryChartComponents = {
  "Key Statistics": KeyStatisticsChart,
  "Cultural, Linguistic and Religious Backgrounds": LanguageAndCultureChart,
  "Socio–economic Characteristics": SocioEconomicCharacteristicsChart,
  "Family and Dwelling Condition": HouseholdsChart,
  "Disability and Unpaid Care": OtherChart,
};

export const categoryTableComponents = {
  "Key Statistics": KeyStatisticsTable,
  "Cultural, Linguistic and Religious Backgrounds": LanguageAndCultureTable,
  "Socio–economic Characteristics": SocioEconomicCharacteristicsTable,
  "Family and Dwelling Condition": HouseholdsTable,
  "Disability and Unpaid Care": OtherTable,
};

/* Based on the thing aggregation we use (any of the 4 Communities or just geo_aggregation)
 * we want to filter out some of the Charts. Here we define which ones should disappear for
 * the given state*/
const excludedCharts = (
  { community, geo_aggregation, geo_aggregation_value },
  showFor,
  isDetailsView = true
) => {
  if (showFor == "geo_aggregation") {
    // if SED geo_aggregation then we remove some more
    if (geo_aggregation_value && geo_aggregation !== "ste") {
      switch (geo_aggregation) {
        case "sed":
          return {
            "Key Statistics": !geo_aggregation_value
              ? ["Population Composition", "Service Age Groups", "LGA Distribution"]
              : ["Service Age Groups", "LGA Distribution"],
            "Socio–economic Characteristics": "*",
            // Employment: "*",
            "Family and Dwelling Condition": "*",
            "Disability and Unpaid Care": "*",
          };
        case "lga": // when LGA is not selected
          if (!geo_aggregation_value)
            return {
              "Key Statistics": ["Population Composition", "Service Age Groups", "LGA Distribution"],
            };
        default:
          return {
            "Key Statistics": ["Service Age Groups","LGA Distribution"],
          };
      }
    } else {
      return {
        "Key Statistics": ["Service Age Groups", "LGA Distribution"],
      };
    }
  } else {
    switch (community) {
      case "Birthplace":
        return {
          "Key Statistics": [
            "Population Composition",
            "Born Overseas",
            "Born in MES and NMES countries",
            "Major Birthplaces",
            "Indigenous Status",
            "Service Age Groups",
          ],
          "Family and Dwelling Condition": [
            "Socioeconomic disadvantage (SEIFA)",
          ],
        };
      case "Religion":
        return {
          "Key Statistics": ["Indigenous Status","Service Age Groups",],
          "Cultural, Linguistic and Religious Backgrounds": [
            "Religious Affiliation",
          ],
          "Family and Dwelling Condition": [
            "Socioeconomic disadvantage (SEIFA)",
          ],
        };
      case "Ancestry":
        return {
          "Key Statistics": ["Indigenous Status","Service Age Groups",],
          "Cultural, Linguistic and Religious Backgrounds": ["Ancestry"],
          "Family and Dwelling Condition": [
            "Socioeconomic disadvantage (SEIFA)",
          ],
        };
      case "Language":
        return {
          "Key Statistics": ["Indigenous Status","Service Age Groups",],
          "Cultural, Linguistic and Religious Backgrounds": [
            "Languages Spoken at Home",
            "LOTE Speakers",
          ],
          "Family and Dwelling Condition": [
            "Socioeconomic disadvantage (SEIFA)",
          ],
        };
      default:
        return {
          "Key Statistics": [
            "Born in MES and NMES countries",
            "Indigenous Status",
            "Service Age Groups",
          ],
        };
    }
  }
};

export const getChartsForDomainData = (
  domain_data,
  showFor,
  isDetailsView = true
) =>
  excludedCharts(domain_data, showFor).chain((_excludedCharts) =>
    Object.keys(categoryChartComponents).reduce(
      (collected, category) =>
        _excludedCharts[category] && _excludedCharts[category] === "*"
          ? collected // when true the whole category is exclude
          : Object.assign(
              // otherwise filter
              collected,
              {
                [category]: Object.keys(
                  categoryChartComponents[category]
                ).reduce((memo, key) => {
                  if (
                    !_excludedCharts[category] ||
                    _excludedCharts[category].indexOf(key) === -1
                  ) {
                    memo[key] = categoryChartComponents[category][key];
                  }
                  return memo;
                }, {}),
              }
            ),
      {}
    )
  );



// WEBPACK FOOTER //
// ./components/Charts/componentFilter.js